module.exports = __webpack_public_path__ + "img/background-logo.b236c017.svg";